const imageCache = new Map<string, HTMLImageElement>();

export default function cachedImageElement(src: string): HTMLImageElement {
  if (imageCache.has(src)) {
    return imageCache.get(src)!;
  }

  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = src;
  imageCache.set(src, img);
  
  return img;
} 